<template>
  <span :class="`${ customStyles ? customStyles : 'roomie-icon' } pointer-events-none`">
    <template v-if="hasSlot">
      <slot />
    </template>
    <component
      :is="componentToRender"
      v-else />
  </span>
</template>

<script>
import * as Vue from 'vue'

export default {
  name: 'RoomieIcon',
  props: {
    customStyles: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasSlot () {
      return (this.$slots && this.$slots.default)
    },
    componentToRender () {
      if (!this.iconName) {
        return null
      }

      let version = Vue.version
      if (!version) {
        version = Vue.default && Vue.default.version
      }

      const isVue3 = /^3\./.test(version)

      if (isVue3){
        return Vue.defineAsyncComponent(()=> import(`./../../assets/icons/${this.iconName}.svg`))
      }

      return  () => import(`./../../assets/icons/${this.iconName}.svg`)
    }
  }
}
</script>

<style
  src="./_index.scss"
  lang="scss"/>
